var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"marginCenter"},[_vm._m(0),_c('div',{staticClass:"query"},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true}},[_c('el-form-item',{attrs:{"label":"进修记录"}},[_c('el-select',{staticStyle:{"width":"420px"},attrs:{"placeholder":"请选择进修记录"},model:{value:(_vm.applyId),callback:function ($$v) {_vm.applyId=$$v},expression:"applyId"}},_vm._l((_vm.applyList),function(apply){return _c('el-option',{key:apply.applyId,attrs:{"label":_vm.selectDictLabel(_vm.dict.type.train_type, apply.trainType) +
                '（' +
                apply.applyBasic.trainBeginDate +
                '~' +
                apply.applyBasic.trainEndDate +
                '）',"value":apply.applyId}})}),1)],1),_c('el-form-item',{staticStyle:{"float":"right"}},[_c('el-button',{staticClass:"fr blueBtn1",staticStyle:{"width":"140px","height":"40px"},attrs:{"type":"primary"},on:{"click":_vm.getTableData}},[_vm._v("查询")])],1)],1)],1),_c('div',{staticClass:"marginBom24",staticStyle:{"color":"#ff0000","font-size":"18px"}},[_vm._v(" 离院流程请使用手机端页面 ")]),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"border":"","header-cell-style":{ backgroundColor: '#f5f5f5' }}},[_c('el-table-column',{attrs:{"prop":"type","label":"进修类型","min-width":"159","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _c('span',{},[_vm._v(" "+_vm._s(_vm.dict.type.train_type.filter((item) => item.value == scope.row.trainType)[0] .label)+" ")])}}])}),_c('el-table-column',{attrs:{"prop":"applyBasic.trainBeginDate","label":"进修申请时间","align":"center","min-width":"220"}}),_c('el-table-column',{attrs:{"prop":"leaveEstimateDate","label":"离院时间","align":"center","min-width":"213"}}),_vm._l((_vm.leaveNodeList),function(item,index){return _c('el-table-column',{key:index,attrs:{"prop":"groupUpdateTime","label":item.nodeName,"align":"center","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(item.nodeType === '0')?_c('span',{class:item.nodeStatus != -1 ? 'pointer fcolor_green' : '',on:{"click":function($event){item.nodeStatus != -1
                ? _vm.$router.push({
                    path: '/leave/detail',
                    query: {
                      applyId: scope.row.applyId,
                      nodeKey: item.nodeKey,
                      state: 0,
                      type: 2,
                      nodeId: item.nodeId,
                      nodeName: item.nodeName,
                      operationType: 0,
                      dept: JSON.stringify(scope.row.applyDeptList[0]),
                    },
                  })
                : false}}},[_vm._v("无需确认")]):(item.nodeType === '2')?_c('span',[(item.nodeStatus != 1)?_c('span',{class:item.nodeStatus != -1 ? 'pointer fcolor_green' : '',on:{"click":function($event){item.nodeStatus != -1
                  ? _vm.$router.push({
                      path: '/leave/detail',
                      query: {
                        applyId: scope.row.applyId,
                        nodeKey: item.nodeKey,
                        state: 0,
                        type: 2,
                        nodeId: item.nodeId,
                        nodeName: item.nodeName,
                        operationType: 2,
                        dept: JSON.stringify(scope.row.applyDeptList[0]),
                      },
                    })
                  : false}}},[_vm._v("未确认")]):_c('span',{class:item.nodeStatus != -1 ? 'pointer fcolor_green' : '',on:{"click":function($event){item.nodeStatus != -1
                  ? _vm.$router.push({
                      path: '/leave/detail',
                      query: {
                        applyId: scope.row.applyId,
                        nodeKey: item.nodeKey,
                        state: 1,
                        type: 2,
                        nodeId: item.nodeId,
                        nodeName: item.nodeName,
                        operationType: 4,
                        dept: JSON.stringify(scope.row.applyDeptList[0]),
                      },
                    })
                  : false}}},[_vm._v("已确认")])]):_c('span',[(item.nodeStatus != 1)?_c('span',{class:item.nodeStatus != -1 ? 'pointer fcolor_green' : '',on:{"click":function($event){item.nodeStatus != -1
                  ? _vm.$router.push({
                      path: '/leave/detail',
                      query: {
                        applyId: scope.row.applyId,
                        nodeKey: item.nodeKey,
                        state: 0,
                        type: 2,
                        nodeId: item.nodeId,
                        nodeName: item.nodeName,
                        operationType: 1,
                        dept: JSON.stringify(scope.row.applyDeptList[0]),
                      },
                    })
                  : false}}},[_vm._v("上传凭证")]):_c('span',{class:item.nodeStatus != -1 ? 'pointer fcolor_green' : '',on:{"click":function($event){item.nodeStatus != -1
                  ? _vm.$router.push({
                      path: '/leave/detail',
                      query: {
                        applyId: scope.row.applyId,
                        nodeKey: item.nodeKey,
                        state: 1,
                        type: 2,
                        nodeId: item.nodeId,
                        nodeName: item.nodeName,
                        operationType: 3,
                        dept: JSON.stringify(scope.row.applyDeptList[0]),
                      },
                    })
                  : false}}},[_vm._v("已上传")])])]}}],null,true)})})],2)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marginBom30 marginTop30 navTitle flex-yCenter flex-sb"},[_c('div',{staticClass:"left flex"},[_c('div',{staticClass:"line"}),_c('span',[_vm._v("离院登记")])])])
}]

export { render, staticRenderFns }